import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SessionProvider, useSession } from './lib/session.js';
import { ToastProvider } from './components/ui.js';
import { AppShell } from './components/AppShell.js';
import { Login } from './pages/Login.js';
import { Overview } from './pages/Overview.js';
import { Inbox } from './pages/Inbox.js';
import { Customers } from './pages/Customers.js';
import { CustomerDetail } from './pages/CustomerDetail.js';
import { Catalog } from './pages/Catalog.js';
import { Agenda } from './pages/Agenda.js';
import { RecordService } from './pages/RecordService.js';
import { RemindersLayout, Sequencias, ProximosEnvios, Pausados, Historico } from './pages/Reminders.js';
import { Intervalos } from './pages/reminders/Intervalos.js';
import {
  SettingsLayout,
  LojaEMarca,
  Descontos,
  Equipe,
  WhatsAppConfig,
  CustosELimites,
} from './pages/settings/Settings.js';
import { Notificacoes } from './pages/settings/Notificacoes.js';
import { MensagensProntas } from './pages/settings/MensagensProntas.js';
import { RegrasIA } from './pages/settings/RegrasIA.js';
import { Retencao } from './pages/settings/Retencao.js';
import { Sistema } from './pages/settings/Sistema.js';
import { Metricas } from './pages/Metricas.js';

function Rotas() {
  const { me, loading } = useSession();

  if (loading) {
    return (
      <div className="login-page">
        <p className="muted">Carregando…</p>
      </div>
    );
  }
  if (!me) return <Login />;

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<TelaInicial />} />
        <Route path="/atendimento" element={<Inbox />} />
        <Route path="/atendimento/:id" element={<Inbox />} />
        <Route path="/clientes" element={<Customers />} />
        <Route path="/clientes/:id" element={<CustomerDetail />} />
        <Route path="/catalogo" element={<Catalog />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/servicos/novo" element={<RecordService />} />
        <Route path="/metricas" element={<Metricas />} />
        <Route path="/lembretes" element={<RemindersLayout />}>
          <Route index element={<Sequencias />} />
          <Route path="proximos" element={<ProximosEnvios />} />
          <Route path="pausados" element={<Pausados />} />
          <Route path="intervalos" element={<Intervalos />} />
          <Route path="historico" element={<Historico />} />
        </Route>
        <Route path="/configuracoes" element={<SettingsLayout />}>
          <Route index element={<LojaEMarca />} />
          <Route path="loja" element={<LojaEMarca />} />
          <Route path="ia" element={<RegrasIA />} />
          <Route path="descontos" element={<Descontos />} />
          <Route path="notificacoes" element={<Notificacoes />} />
          <Route path="mensagens-prontas" element={<MensagensProntas />} />
          <Route path="equipe" element={<Equipe />} />
          <Route path="whatsapp" element={<WhatsAppConfig />} />
          <Route path="custos" element={<CustosELimites />} />
          <Route path="retencao" element={<Retencao />} />
          <Route path="sistema" element={<Sistema />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

/**
 * Onde cada pessoa abre o painel. Quem atende cai no Atendimento: é onde o
 * trabalho acontece, e navegar até lá todo dia é atrito diário sem motivo.
 * O destino vem do SERVIDOR (papel do usuário), não de um palpite da tela.
 */
function TelaInicial() {
  const { me } = useSession();
  const destino = me?.telaInicial ?? '/';
  if (destino !== '/') return <Navigate to={destino} replace />;
  return <Overview />;
}

export function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <ToastProvider>
          <Rotas />
        </ToastProvider>
      </SessionProvider>
    </BrowserRouter>
  );
}
